import {ElementClipboardEvent} from 'util/Types';

/**
 * Users often paste a spreadsheet column, where values are delimited by \n or \r or \r\n.
 * HTML inputs are single-line, and convert pasted \n and \r into spaces. Thus we explicitly convert these
 * to \t to preserve delimiting.
 */
export default function insertTextFromPaste(e: ElementClipboardEvent): void {
  e.preventDefault();
  const text = e.clipboardData.getData('text/plain');
  const newText = text.replace(/[\n\r\t]+/g, ',');
  document.execCommand('insertText', false, newText);
}
